export const MAX_PHOTOS_IN_COLLAGE = 8;

export const PHOTO_COLLAGE_ROWS_GAP = 12;

// Justified gallery rows aim at this height; GALLERY_GAP must match $gallery-gap
// in DentalPhotoAlbumGallery.module.scss.
export const GALLERY_ROW_HEIGHT = 160;
export const GALLERY_GAP = 8;
export const GALLERY_UPLOAD_TILE_ID = 'upload';
